/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';
interface IUserPreferencePayload {
  user_id?: string;
  theme_preference?: string;
  team?: string;
  preferred_language?: string;
}

export const UsersAPI = {
  syncDomainGroup: async () =>
    (await initAxios())
      ?.post('/users/sync-domain')
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getAllUsers: async () =>
    (await initAxios())
      ?.get('/_sa/users')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  checkExistingUser: async (user: any) =>
    (await initAxios())
      ?.post('/_sa/users/verify/existing-user', JSON.stringify(user))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  createUser: async (user: any) =>
    (await initAxios())
      ?.post('/_sa/users/create-new', JSON.stringify(user))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getUsers: async (company_id: string) =>
    (await initAxios())
      ?.get(`/users/bycompany/${company_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getUsersBatch: async (groupIds: string[]) => {
    if (groupIds.length === 0) return { success: true, result: {} };
    return (await initAxios())
      ?.get(`/users/bycompany/batch?ids=${groupIds.join(',')}`)
      .then((resp) => ({ success: true, result: resp.data?.data ?? {} }))
      .catch((err) => ({ success: false, result: parseErrorMsg(err) }));
  },

  getUser: async (user_id: string) =>
    (await initAxios())
      ?.get(`/users/${user_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  searchUsers: async (query: string) =>
    (await initAxios())
      ?.post(`/users/search/${query}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateUser: async (user_id: string, user: any) =>
    (await initAxios())
      ?.put(`/users/${user_id}`, JSON.stringify(user))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateTariffLeaveWarningPreference: async (
    user_id: string,
    optedOut: boolean,
  ) =>
    (await initAxios())
      ?.put(`/users/${user_id}/preferences/tariff-leave-warning`, {
        optedOut: optedOut,
      })
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  sendPasswordResetEmail: async (user_id: string) =>
    (await initAxios())
      ?.post(`/users/${user_id}/reset-password`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  sendMfaSetupEmail: async (user_id: string) =>
    (await initAxios())
      ?.post(`/users/${user_id}/mfa/enable`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  disableMfa: async (user_id: string) =>
    (await initAxios())
      ?.post(`/users/${user_id}/mfa/disable`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteOwnAccount: async (user_id: string, current_team_id: string) =>
    (await initAxios())
      ?.post(
        `/users/${user_id}/delete-account`,
        JSON.stringify({
          current_team_id: current_team_id,
        }),
      )
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getUserPreferencesByUserId: async (user_id: string) =>
    (await initAxios())
      ?.get(`/users/preferences/${user_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  createUserPreferences: async (preferences: IUserPreferencePayload) =>
    (await initAxios())
      ?.post('/users/preferences', JSON.stringify(preferences))
      .then((resp) => {
        return {
          success: resp.status === 201,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateUserPreferencesByUserId: async (
    user_id: string,
    preferences: IUserPreferencePayload,
  ) =>
    (await initAxios())
      ?.put(`/users/preferences/${user_id}`, JSON.stringify(preferences))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteUser: async (user_id: string) =>
    (await initAxios())
      ?.delete(`/users/${user_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  addRoleToUser: async (user_id: string, role_id: string, role_name: string) =>
    (await initAxios())
      ?.post(`/users/${user_id}/roles/${role_id}/name/${role_name}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  addAdminToUser: async (
    user_id: string,
    client_id: string,
    role_id: string,
    role_name: string,
  ) =>
    (await initAxios())
      ?.post(
        `/users/${user_id}/${client_id}/roles/${role_id}/name/${role_name}`,
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  removeAdminFromUser: async (
    user_id: string,
    client_id: string,
    role_id: string,
    role_name: string,
  ) =>
    (await initAxios())
      ?.delete(
        `/users/${user_id}/${client_id}/roles/${role_id}/name/${role_name}`,
      )
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getLoginEventCount: async (userId: string, days = 30) =>
    (await initAxios())
      ?.post('/login-events', JSON.stringify({ userId: userId, days: days }))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getMyTableColumns: async (tableKey: string) =>
    (await initAxios())
      ?.get(`/users/me/table-columns/${encodeURIComponent(tableKey)}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  saveMyTableColumns: async (tableKey: string, columns: string[]) =>
    (await initAxios())
      ?.put(
        `/users/me/table-columns/${encodeURIComponent(tableKey)}`,
        JSON.stringify({ columns: columns }),
      )
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default UsersAPI;
